import Cookie from "js-cookie";
import { CookieKeys } from "../constants";

export const clearStorage = () => {
  Cookie.remove(CookieKeys.TOKEN);
  localStorage.clear();
  sessionStorage.clear();
};

export const getAuthToken = () => Cookie.get(CookieKeys.TOKEN);
export const setAuthToken = (token: string) =>
  Cookie.set(CookieKeys.TOKEN, token);

export const setRedirectRoute = (pathname: string) =>
  sessionStorage.setItem(CookieKeys.REDIRECT_ROUTE, pathname);

export const getRedirectRoute = () => {
  const val = sessionStorage.getItem(CookieKeys.REDIRECT_ROUTE);

  return val;
};
